import { token } from '@cp/shared/di';
import { EventBus } from './eventBus';

export const EVENT_BUS_TOKEN = token<EventBus>('EventBus');
